
import { GameState } from '../GameContextTypes';

export const makeDecision = (state: GameState, decision: string, outcome: string): GameState => {
  if (!state.currentChallenge) return state;
  
  // Experience gain scales with challenge difficulty
  const expGained = state.currentChallenge.difficulty * (5 + Math.floor(Math.random() * 5));
  
  // Modify the decision history to include more information
  const challengeDifficulty = state.currentChallenge.difficulty;
  const careerYear = state.yearsPassed;
  
  // Add random small bonuses based on career level
  let bonusMultiplier = 1.0;
  switch (state.careerLevel) {
    case 'Mid-Level':
      bonusMultiplier = 1.1;
      break;
    case 'Senior':
      bonusMultiplier = 1.2;
      break;
    case 'Leader':
      bonusMultiplier = 1.3;
      break;
    case 'Expert':
      bonusMultiplier = 1.5;
      break;
    default:
      bonusMultiplier = 1.0; // Junior level default
  }
  
  // Award achievement points for difficult challenges
  let updatedAchievements = [...state.achievements];
  if (challengeDifficulty >= 4) {
    const challengeName = state.currentChallenge.title;
    if (!updatedAchievements.includes(`Overcame ${challengeName} challenge`)) {
      updatedAchievements.push(`Overcame ${challengeName} challenge`);
    }
  }
  
  // Calculate final experience with bonuses
  const finalExpGained = Math.floor(expGained * bonusMultiplier);
  
  // Track completed challenges to avoid repetition
  const completedChallengeId = state.currentChallenge.id;
  let updatedCompletedChallenges = [...(state.completedChallenges || [])];
  
  // Add to completed challenges if not already there
  if (!updatedCompletedChallenges.includes(completedChallengeId)) {
    updatedCompletedChallenges.push(completedChallengeId);
    // Limit to last 20 challenges to prevent excessive storage
    if (updatedCompletedChallenges.length > 20) {
      updatedCompletedChallenges = updatedCompletedChallenges.slice(-20);
    }
  }
  
  // Log that we're clearing the challenge
  console.log('Clearing challenge after decision:', state.currentChallenge.title);
  
  return {
    ...state,
    experience: state.experience + finalExpGained,
    achievements: updatedAchievements,
    completedChallenges: updatedCompletedChallenges,
    decisionHistory: [
      ...state.decisionHistory,
      {
        challenge: state.currentChallenge.title,
        decision,
        outcome,
        date: new Date(),
      },
    ],
    // Directly set the currentChallenge to null to ensure it's cleared immediately
    currentChallenge: null
  };
};
